export default __webpack_public_path__ + "static/media/IBimageKneeanglemidstance2.044c3236.png";